export default {
  "generic": {
    'top': "Top",
    'home': "Home",
    'about': "About",
    'contact': "Contact",
    'title': "INU Appcenter",
    'about': "INU Appcenter is an academic club focused on mobile and web application developments, based in Incheon National University.",
  },
}



// WEBPACK FOOTER //
// ./src/locale/en.js